module.exports = __webpack_public_path__ + "static/img/共享专用电单车.a207335.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/共享专用电单车.jpg
// module id = Xc1y
// module chunks = 1